import { useIsIcebergEnabled } from "src/hooks/useIsIcebergEnabled";
import { useWorkspaceContext } from "src/router/routerContextHooks";

/**
 * Hook to determine if Iceberg should be used for metrics endpoints
 *
 * Returns true if either:
 * - The workspace config `enable_dhv2_metrics` is enabled, OR
 * - Falls back to the existing `useIsIcebergEnabled()` behavior
 *
 * Use this hook for metrics endpoints that support Iceberg reads:
 * - /metrics/api/v1/operational/summary
 * - /metrics/api/v1/decision_summary
 * - /metrics/api/v1/operational/latency
 * - /metrics/api/v1/operational/errors
 * - /metrics/api/v1/operational/decisions
 *
 */
export const useIsIcebergMetricsEnabled = (): boolean => {
  const { workspace } = useWorkspaceContext();
  const isIcebergEnabled = useIsIcebergEnabled();

  // New flag takes precedence - when enabled, always use iceberg for metrics
  if (workspace.config?.enable_dhv2_metrics) {
    return true;
  }

  // Fall back to existing iceberg behavior
  return isIcebergEnabled;
};
